import { gql } from '@apollo/client';

export type { GetOrganization as IGetOrganization } from './__generated__/GetOrganization';

export const GET_ORGANIZATION = gql`
  query GetOrganization {
    organization {
      identifier
      slug
      partnershipType
    }
  }
`;
